import React, { useState, useEffect } from "react";
import "./treemapTable.css";
import { filterDataByCategory } from "../Utils/CategoriesFilter";
import { getQualityClassName } from "../Utils/QualitySelector";

function TreemapTable({ 
  selectedNodeName,  
  qualityFilter
}) {
  const [categoryFilter, setCategoryFilter] = useState(selectedNodeName);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
 
  const filteredData = 
    filterDataByCategory(categoryFilter, data);
  

  useEffect(() => {
    const fetchData = async () => {
      const dataFromStorage = await JSON.parse(localStorage.getItem("UpdatedDataArray"));
      setData(dataFromStorage || []);
      setLoading(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    console.log("node:", selectedNodeName)
      setCategoryFilter(selectedNodeName);
  }, [selectedNodeName]);

  const filteredDataByQuality =
    qualityFilter === "All"
      ? filteredData // Use filteredData when "All" is selected for quality
      : filteredData.filter((row) => {
          const qualityValue = row["Quality (per value)"];
          if (qualityFilter === "medium-quality") {
            return qualityValue >= 4 && qualityValue <= 7;
          } else if (qualityFilter === "high-quality") {
            return qualityValue >= 8 && qualityValue <= 10;
          } else if (qualityFilter === "low-quality") {
            return qualityValue >= 1 && qualityValue <= 3;
          }
          return false;
        });

  return (
    <div className="treemap-tb-cnt">
      {loading ? (
        // Display a loading message or spinner while data is loading
        <p>Loading...</p>
      ) : filteredDataByQuality.length === 0 ? (
        <p className="treemap-no-qualitydata">
          There are no rows with that quality value.
        </p>
      ) : (
        <table id="treemap-table">
          <thead>
            <tr>
              <th>Category</th>
              <th>Property</th>
              <th>Value</th>
              <th>Quality</th>
            </tr>
          </thead>
          <tbody>
            {filteredDataByQuality.map((row, index) => (
              <tr key={index}>
                <td>{row["Category (per property)"]}</td>
                <td>{row["Property"]}</td>
                <td>{row["Value (per property)"]}</td>
                <td className={getQualityClassName(row["Quality (per value)"])}>
                  {row["Quality (per value)"]}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default TreemapTable;
